<script>
  /**
   * DriveReport 編集時の日付、名前の選択コンポーネント
   *  日付と名前からハッシュでドキュメントIDを生成する
   */
  import md5 from 'md5'
  import { DateTime } from 'luxon'

  import TextInput from './inputs/TextInput.svelte'
  import RadioSelect from './inputs/RadioSelect.svelte'

  export let date = DateTime.local().toFormat('yyyy-MM-dd') // 日付の初期値を設定
  export let reporterName = null // 報告者名
  export let reportId = null // 運転日報のドキュメントID

  $: {
    // MD5 ハッシュで ドキュメントIDを求める
    reportId = date && reporterName ? md5(date + reporterName) : null
  }

  // デバッグ表示
  $: console.log({ date, reporterName, reportId })
</script>

<div class="box has-background-primary-light">
  <RadioSelect
    name="reporterName"
    label="報告者名"
    options={['西脇 ゆうこ', '長郷 正男']}
    bind:value={reporterName}
  />

  <TextInput name="date" label="日付" type="date" bind:value={date} />
</div>
